
export default function GlobalContext() {
  return (
    <section id="global-context" className="bg-gradient-to-br from-[#F0F7FF] via-white to-[#EAF3FF] py-16 sm:py-20 lg:py-24 px-4 sm:px-8">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <h2 className="text-[32px] sm:text-[42px] lg:text-[56px] font-black text-[#0066FF] uppercase tracking-tight mb-6 sm:mb-8">
          GLOBAL CONTEXT
        </h2>

        {/* People Icons Row */}
        <div className="hidden sm:flex items-end gap-2 mb-8 lg:mb-12">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <i
                className={`ri-user-3-fill text-2xl ${
                  i % 4 === 0 ? "text-[#0066FF]" : "text-gray-300"
                }`}
              ></i>
              {i % 4 === 0 && (
                <i className="ri-drop-fill text-sm text-[#0066FF]"></i>
              )}
            </div>
          ))}
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left Column - Cards */}
          <div className="flex flex-col gap-6">
            {/* Card 1 - 2.2 Billion People */}
            <div className="bg-[#E8F4FF] rounded-2xl sm:rounded-3xl p-6 sm:p-10 flex items-center gap-0">
              {/* Left part */}
              <div className="flex flex-col items-start justify-center flex-shrink-0 pr-6 sm:pr-8">
                <span className="text-[72px] sm:text-[96px] lg:text-[112px] font-black text-[#1565C0] leading-none">≈2,2</span>
                <div className="flex flex-col leading-tight mt-1">
                  <span className="text-[18px] sm:text-[22px] lg:text-[26px] font-bold text-[#1565C0] leading-none">BILLION</span>
                  <span className="text-[18px] sm:text-[22px] lg:text-[26px] font-bold text-[#1565C0] leading-none">PEOPLE*</span>
                </div>
              </div>
              {/* Right part */}
              <div className="pl-6 sm:pl-8">
                <p className="text-sm sm:text-base text-[#0A1628]/70 font-medium leading-snug">
                  worldwide lack{" "}
                  <strong className="text-[#0A1628]">
                    sustainable access<br />
                    to safe drinking water
                  </strong>
                </p>
              </div>
            </div>

            {/* Grid Row */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Card 2 - 80% Wastewater */}
              <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden min-h-[220px] sm:min-h-[240px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/f5e0aea82b06530abf3a870e91fedecf.jpg"
                  alt="Wastewater Analysis"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-[#0044CC]/80 via-[#0066FF]/60 to-[#00AAFF]/50"></div>
                <div className="relative h-full flex flex-col justify-between p-6 sm:p-8">
                  <div>
                    <div className="text-[10px] sm:text-xs font-bold text-white/70 uppercase tracking-widest mb-1">UP</div>
                    <div className="text-[56px] sm:text-[72px] lg:text-[80px] font-black text-white leading-none">
                      80<span className="text-[28px] sm:text-[36px] lg:text-[42px]">%</span>
                    </div>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm font-bold text-white uppercase mb-2 tracking-wide">
                      OF WASTEWATER
                    </div>
                    <p className="text-xs sm:text-sm text-white/90">
                      globally is discharged<br />
                      <span className="text-white font-bold">
                        without adequate treatment
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 3 - 30-50% Water Losses */}
              <div className="bg-white border-2 border-[#0066FF]/20 rounded-2xl sm:rounded-3xl p-6 sm:p-8">
                <div className="text-[40px] sm:text-[52px] lg:text-[64px] font-black text-[#0066FF] leading-none mb-2 sm:mb-3">
                  30-50<span className="text-[24px] sm:text-[30px] lg:text-[36px]">%</span>
                </div>
                <div className="text-xs sm:text-sm font-bold text-[#0A1628] uppercase mb-2">
                  WATER LOSSES
                </div>
                <p className="text-xs sm:text-sm text-[#0A1628]/70">
                  occur in{" "}
                  <strong className="text-[#0A1628]">
                    aging water supply<br />
                    systems
                  </strong>{" "}
                  in a number of regions
                </p>
              </div>
            </div>

            {/* Card 4 - 4 Billion Photo Card */}
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden flex-1 min-h-[220px] sm:min-h-[240px]">
              <img
                src="https://readdy.ai/api/search-image?query=close-up%20of%20cupped%20hands%20holding%20water%20droplets%20in%20black%20and%20white%2C%20water%20scarcity%20concept%2C%20human%20hands%20catching%20precious%20water%2C%20dramatic%20lighting%2C%20environmental%20crisis%20photography&width=800&height=280&seq=global-context-water-hands&orientation=landscape"
                alt="Water Scarcity"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
              <div className="relative h-full flex flex-col justify-center p-6 sm:p-10">
                <div className="text-[28px] sm:text-[36px] lg:text-[44px] font-black text-white leading-none mb-3 sm:mb-4 whitespace-nowrap">
                  <span className="text-[48px] sm:text-[64px] lg:text-[80px]">≈4</span>{" "}
                  <span className="text-[22px] sm:text-[28px] lg:text-[34px] font-bold">BILLION PEOPLE</span>
                </div>
                <p className="text-sm sm:text-base text-white font-medium">
                  experience <strong>acute water scarcity</strong>
                  <br />
                  for at least one month per year
                </p>
              </div>
            </div>
          </div>

          {/* Right Column - Burden & Implications */}
          <div className="flex flex-col gap-6 relative">
            {/* Burden Section */}
            <div className="bg-[#F8FAFB] rounded-2xl sm:rounded-3xl p-6 sm:p-10">
              <div className="flex items-start gap-3 mb-6 sm:mb-8">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-right-down-line text-[32px] sm:text-[40px] text-[#0066FF]"></i>
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-black text-[#3B3F45] uppercase leading-tight pt-1 sm:pt-2">
                  THE BURDEN<br />
                  OF WATER STRESS<br />
                  FALLS PRIMARILY ON:
                </h3>
              </div>

              <div className="space-y-4 sm:space-y-6 pl-0 sm:pl-4">
                {/* Rural Areas */}
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-home-4-line text-[24px] sm:text-[28px] text-[#0066FF]"></i>
                  </div>
                  <p className="text-base sm:text-lg text-[#3B3F45]/70 pt-1 sm:pt-2">
                    rural areas;
                  </p>
                </div>

                {/* Rapidly Growing Cities */}
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-line text-[24px] sm:text-[28px] text-[#0066FF]"></i>
                  </div>
                  <p className="text-base sm:text-lg text-[#3B3F45]/70 pt-1 sm:pt-2">
                    rapidly growing cities;
                  </p>
                </div>

                {/* Drought Regions */}
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-sun-line text-[24px] sm:text-[28px] text-[#0066FF]"></i>
                  </div>
                  <p className="text-base sm:text-lg text-[#3B3F45]/70 pt-1 sm:pt-2">
                    regions exposed to drought and limited<br className="hidden sm:inline" />
                    infrastructure investment.
                  </p>
                </div>
              </div>
            </div>

            {/* Implications Section */}
            <div className="flex-1 relative rounded-2xl sm:rounded-3xl p-6 sm:p-10 flex flex-col justify-center overflow-hidden" style={{background: 'linear-gradient(135deg, #f0f7ff 0%, #e8f2ff 40%, #f5faff 100%)'}}>
              {/* Accent blue spot */}
              <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full opacity-30 pointer-events-none" style={{background: 'radial-gradient(circle, #0066FF 0%, #00D4FF 50%, transparent 75%)'}}></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 rounded-full opacity-15 pointer-events-none" style={{background: 'radial-gradient(circle, #0044CC 0%, transparent 70%)'}}></div>
              <h4 className="relative text-lg sm:text-xl font-black text-[#0A1628] uppercase mb-4 sm:mb-6 tracking-wide">
                IMPLICATIONS:
              </h4>
              <p className="relative text-sm sm:text-base text-[#3B3F45]/80 leading-relaxed mb-3 sm:mb-4">
                Water stress increasingly manifests{" "}
                <strong className="text-[#0A1628]">
                  not as a localized emergency
                </strong>
                , but as a{" "}
                <strong className="text-[#0A1628]">
                  persistent environmental condition
                </strong>
                , in which large population groups regularly face
                insufficient access to safe drinking water.
              </p>
              <p className="relative text-sm sm:text-base text-[#3B3F45]/80 leading-relaxed">
                This means that water supply challenges are no longer
                isolated or temporary, but take on a{" "}
                <strong className="text-[#0A1628]">
                  systemic and recurring character
                </strong>
                .
              </p>
            </div>
          </div>
        </div>

        {/* Source Footer */}
        <div className="mt-6 sm:mt-8 text-xs text-[#0A1628]/50">
          *Source: UN-Water GLAAS Global Update 2025 (WHO/UNICEF)
        </div>
      </div>
    </section>
  );
}
